import { Component, Input } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { Subscription, interval, switchMap, tap } from "rxjs";
import {
  otpSendActivateApi,
  otpVerifyActivateApi,
  otpVerifyResetApi,
  resetPasswordApi,
  signupApi,
} from "../../services/constants/api.constants";
import {
  ToastService,
  AuthService,
  HelpersService,
  HttpBaseService,
} from "@evento-ng/libs";
import { Toast } from "src/app/services/enums/toast";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
} from "src/app/services/constants/general.constants";

@Component({
  selector: "app-login-popup",
  templateUrl: "./login-popup.component.html",
  styleUrls: ["./login-popup.component.scss"],
})
export class LoginPopupComponent {
  public loginForm!: FormGroup;
  public signupForm!: FormGroup;
  public forgetPasswordForm!: FormGroup;
  changePasswordForm!: FormGroup;
  @Input() formToShow: any;
  showLogin = true;
  showSignUpForm = false;
  showOtpForm = false;
  showForgetPasswordForm = false;
  showChangePasswordForm = false;
  isAgree!: boolean;
  id!: string;
  code = new FormControl("");
  action = "";
  englishLettersPattern = "^[a-zA-Z]+$";
  arabicLettersPattern =
    "^[\u0600-\u06FF\u0750-\u077F\uFB50-\uFDFF\uFE70-\uFEFFp{L}]+$";
  showResend!: boolean;
  token: string = "";
  timeDifference: any;
  secondsToDday: any;
  minutesToDday: any;
  secondsToDdayString: any;
  minutesToDdayString: any;
  tryagain = false;
  milliSecondsInASecond = 1000;
  minutesInAnHour = 60;
  SecondsInAMinute = 60;
  expiresAt!: string;
  subs: Subscription[] = [];
  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private dataService: HttpBaseService,
    private router: Router,
    private helpers: HelpersService,
    private toast: ToastService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) {}
  dismiss() {
    this.modalService.dismissAll();
  }

  ngOnInit() {
    if (this.formToShow == "signup") {
      this.initSignup();
      this.showLogin = false;
      this.showSignUpForm = true;
      this.showOtpForm = false;
      this.showForgetPasswordForm = false;
      this.showChangePasswordForm = false;
    } else {
      this.initLogin();
      this.showLogin = true;
      this.showSignUpForm = false;
      this.showOtpForm = false;
      this.showForgetPasswordForm = false;
      this.showChangePasswordForm = false;
    }
  }

  login(): void {
    this.spinner.show();
    const { username, password } = this.loginForm.value;
    this.authService.signIn(username, password).subscribe((res) => {
      this.helpers.setItemToLocalStorage(ACCESS_TOKEN, res.access_token);
      this.helpers.setItemToLocalStorage(REFRESH_TOKEN, res.refresh_token);
      this.authService.fetchUser();
      this.dismiss();
      window.location.reload();
      this.spinner.hide();
    });
  }

  reset(): void {
    this.spinner.show();
    this.recaptchaV3Service
      .execute("otpResendApi")
      .pipe(
        switchMap((token) => {
          return this.dataService.post(
            `${resetPasswordApi}`,
            {
              mobile: this.forgetPasswordForm.value.mobile.number,
              mobileRegionCode:
                this.forgetPasswordForm.value.mobile.countryCode,
              recaptcha: token,
            },
            { headers: { "Accept-Language": this.translate.currentLang } }
          );
        }),
        tap((_) => {
          this.spinner.hide();
          this.action = "reset";
          this.otpShow();
        })
      )
      .subscribe();
  }

  forgetPassword() {
    this.showOtpForm = false;
    this.showLogin = false;
    this.showSignUpForm = false;
    this.showForgetPasswordForm = true;
    this.showChangePasswordForm = false;
    this.initForgetPasswordForm();
  }

  private initSignup(): void {
    this.signupForm = this.formBuilder.group(
      {
        firstName: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30),
            this.helpers.noSpecialCharsAndTrim,
          ],
        ],
        lastName: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30),
            this.helpers.noSpecialCharsAndTrim,
          ],
        ],
        email: ["", [Validators.required, Validators.email]],
        mobileRegionCode: [""],
        mobile: [{ value: "mobile" }, [Validators.required]],
        password: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", [Validators.required, Validators.minLength(6)]],
      },
      {
        validators: [this.MustMatch("password", "confirmPassword")],
      }
    );
  }

  private initForgetPasswordForm(): void {
    this.forgetPasswordForm = this.formBuilder.group({
      mobile: ["", [Validators.required]],
    });
  }
  private initChangePasswordForm(): void {
    this.changePasswordForm = this.formBuilder.group(
      {
        password: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", [Validators.required, Validators.minLength(6)]],
      },
      {
        validators: [this.MustMatch("password", "confirmPassword")],
      }
    );
  }

  MustMatch(controlName: string, matchingControlName: string): any {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors["mustMatch"]) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  signUpshow() {
    this.showOtpForm = false;
    this.showLogin = false;
    this.showSignUpForm = true;
    this.showChangePasswordForm = false;
    this.initSignup();
  }

  loginshow() {
    this.showOtpForm = false;
    this.showSignUpForm = false;
    this.showLogin = true;
    this.showChangePasswordForm = false;
    this.initLogin();
  }

  otpShow() {
    this.showSignUpForm = false;
    this.showLogin = false;
    this.showForgetPasswordForm = false;
    this.showOtpForm = true;
    this.showChangePasswordForm = false;
    this.startSession();
  }

  changePasswordShow() {
    this.showSignUpForm = false;
    this.showLogin = false;
    this.showForgetPasswordForm = false;
    this.showOtpForm = false;
    this.showChangePasswordForm = true;
    this.initChangePasswordForm();
  }

  initLogin() {
    this.loginForm = this.formBuilder.group({
      // username: [null, [Validators.required, Validators.email]],
      mobileRegionCode: [""],
      username: [{ value: "mobile" }, [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(6)]],
    });
  }

  toggleAgree(event: any): void {
    if (event.target.checked) {
      this.isAgree = true;
      return;
    }
    this.isAgree = false;
  }

  signup(): void {
    this.spinner.show();
    this.recaptchaV3Service.execute("signUp").subscribe((token) => {
      const body = {
        ...this.signupForm.getRawValue(),
        firstName: this.signupForm.getRawValue().firstName.trim(),
        lastName: this.signupForm.getRawValue().lastName.trim(),
        recaptcha: token,
        mobile: this.signupForm.getRawValue().mobile.number,
        mobileRegionCode: this.signupForm.getRawValue().mobile.countryCode,
      };
      return this.dataService
        .post(`${signupApi}`, body, {
          headers: { "Accept-Language": this.translate.currentLang },
        })
        .subscribe((res) => {
          this.action = "activate";
          this.otpShow();
          this.id = res.id;
          this.spinner.hide();
        });
    });
  }

  verifyCode(): void {
    this.spinner.show();
    this.recaptchaV3Service
      .execute("otpVerifyApi")
      .pipe(
        switchMap((token) => {
          return this.dataService.post(
            `${
              this.action == "reset" ? otpVerifyResetApi : otpVerifyActivateApi
            }`,
            {
              code: this.code.value,
              mobile:
                this.action == "reset"
                  ? this.forgetPasswordForm.getRawValue().mobile.number
                  : this.signupForm.getRawValue().mobile.number,
              mobileRegionCode:
                this.action == "reset"
                  ? this.forgetPasswordForm.getRawValue().mobile.countryCode
                  : this.signupForm.getRawValue().mobile.countryCode,
              recaptcha: token,
            },
            {
              headers: { "Accept-Language": this.translate.currentLang },
            }
          );
        })
      )
      .subscribe({
        next: (res: any) => {
          this.token = res.message;
          this.action === "reset"
            ? this.changePasswordShow()
            : this.loginshow();
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  openLinkInNewWindow(path: string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`${path}`])
    );

    window.open(url, "_blank");
  }

  resendActivationCode(): void {
    this.spinner.show();
    this.recaptchaV3Service
      .execute("otpResendApi")
      .pipe(
        switchMap((token) => {
          return this.dataService.post(
            `${this.action == "reset" ? resetPasswordApi : otpSendActivateApi}`,
            {
              mobile:
                this.action == "reset"
                  ? this.forgetPasswordForm.getRawValue().mobile.number
                  : this.signupForm.getRawValue().mobile.number,
              mobileRegionCode:
                this.action == "reset"
                  ? this.forgetPasswordForm.getRawValue().mobile.countryCode
                  : this.signupForm.getRawValue().mobile.countryCode,
              recaptcha: token,
            },
            { headers: { "Accept-Language": this.translate.currentLang } }
          );
        }),
        tap((_) => {
          this.spinner.hide();
          this.showResend = false;
          this.startSession();
          this.toast.show("Success", _.message, {
            classname: Toast.success,
          });
        })
      )
      .subscribe();
  }

  private allocateTimeUnits(timeDifference: any) {
    this.secondsToDday = Math.floor(
      (timeDifference / this.milliSecondsInASecond) % this.SecondsInAMinute
    );
    this.secondsToDdayString =
      this.secondsToDday.toString().length == 1
        ? "0" + this.secondsToDday.toString()
        : this.secondsToDday.toString();
    this.minutesToDday = Math.floor(
      (timeDifference / (this.milliSecondsInASecond * this.minutesInAnHour)) %
        this.SecondsInAMinute
    );
    this.minutesToDdayString =
      this.minutesToDday.toString().length == 1
        ? "0" + this.minutesToDday.toString()
        : this.minutesToDday.toString();

    if (this.secondsToDday == 0 && this.minutesToDday == 0) {
      this.subs[1].unsubscribe();
      this.showResend = true;
    }
    if (this.secondsToDday == 0 && this.minutesToDday == 0) {
      this.subs[1].unsubscribe();
      this.showResend = true;
    }
  }

  private getTimeDifference() {
    let d = new Date();
    if (new Date(this.expiresAt).getTime() > d.getTime()) {
      this.timeDifference = new Date(this.expiresAt).getTime() - d.getTime();
      this.allocateTimeUnits(this.timeDifference);
    } else {
      this.tryagain = true;
    }
  }

  startSession() {
    this.expiresAt = this.AddMinutesToDate(new Date(), 5).toISOString();
    this.subs.push(
      interval(1000).subscribe((x) => {
        this.getTimeDifference();
      })
    );
  }

  AddMinutesToDate(date: any, minutes: any) {
    return new Date(date.getTime() + minutes * 60000);
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  changePassword() {
    this.recaptchaV3Service
      .execute("changePasswordApi")
      .pipe(
        switchMap((token) => {
          return this.dataService.put(
            `${resetPasswordApi}/change-password/${this.token}`,
            {
              ...this.changePasswordForm.value,
              recaptcha: token,
            }
          );
        }),
        tap((_) => {
          this.spinner.hide();
          this.toast.show(
            "Success",
            this.translate.instant("Password has been changed"),
            {
              classname: Toast.success,
            }
          );
          this.loginshow();
        })
      )
      .subscribe();
  }
}
